export default __webpack_public_path__ + "static/media/quick-tip-img.069a5564.jpg";